export const tabSelectMobile = `
    <div>
        <select :value="currentTab" :class="selectClass" v-on:change="change">
            <option v-for="o in options" :value="o.id">{{o.text}}</option>
        </select>
        <slot></slot>
    </div>
`;

export const productItem = `
    <div class="product-card-hor" :checked="checked" :data="data">
        <div class="product-card-hor__wrapper">
            <div class="product-card-hor__row">
                <div class="product-card-hor__area product-card-hor__area-utils">
                    <div class="product-card-hor__util product-card-hor__util-checkbox">
                        <div class="checkbox">
                            <label class="checkbox__label">
                                <input type="checkbox" class="checkbox__input" v-model="isChecked" :data-product-id="data.id" ref="checkbox">
                                <span class="checkbox__checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="product-card-hor__util product-card-hor__util-bookmark">
                        <div class="product-bookmark-container">
                            <product-bookmark inline-template :data="data">
                                <span class="product-card-hor__bookmark" :data-product-id="data.id" ref="bookmark" v-on:click="handleBookmark()" v-bind:class="isBookmarked ? 'active' : ''"></span>
                            </product-bookmark>
                        </div>
                    </div>
                </div>
                <div class="product-card-hor__area product-card-hor__area-image">
                    <div class="product-card-hor__image-container">
                        <img :src="data.productImageUrl" :alt="data.productImageUrlAltText" class="product-card-hor__image">
                    </div>
                </div>
                <div class="product-card-hor__area product-card-hor__area-content">
                    <div>
                        <span class="product-card-hor__eyebrow">
                            <img :src="data.brandImageUrl" :alt="data.brandImageUrlAltText" class="product-card-hor__eyebrow-image">
                        </span>
                        <p class="product-card-hor__title">
                            \{{data.productName}}
                        </p>
                        <div class="product-card-hor__copy">
                            \{{data.description}}
                        </div>
                        <div class="product-card-hor__cta">
                        <a :href="data.url" class="button tertiary-button"><span class="button-text">View product</span><span class="button-icon"></span></a>
                        
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
`;

export const documentItem = `
<div class="doc-card">
    <div class="doc-card__wrapper">
        <div class="doc-card__row">
            <div class="doc-card__area doc-card__area-left">
                <span class="doc-card__eyebrow">
                    \{{data.eyebrow}}
                </span>
                <a href="#" class="doc-card__title">
                    \{{data.name}}
                </a>
                <span class="doc-card__subtitle">
                    \{{data.details}}
                </span>
            </div>
            <div class="doc-card__area doc-card__area-right">
                <a class="doc-card__icon doc-card__icon-download" :href="data.url"></a>
                <a class="doc-card__icon doc-card__icon-email" :href="mailto"></a>
                <document-bookmark inline-template :data="data">
                <a class="doc-card__icon doc-card__icon-bookmark" v-on:click.prevent="handleBookmark()" :data-document-id="data.id" ref="bookmark"></a>
                </document-bookmark>
            </div>
        </div>
    </div>
</div>
`;

export const softwareItem = `
    <div class="software-card">
        <div class="software-card__wrapper">
            <div class="software-card__row">
                <div class="software-card__area software-card__area-left">
                    <span class="software-card__eyebrow">
                       \{{data.eyebrow}}
                    </span>
                    <a href="#" class="software-card__title">
                        \{{data.name}}
                    </a>
                    <span class="software-card__subtitle" v-html="data.details">
                        
                    </span>
                </div>
                <div class="software-card__area software-card__area-right">
                    <a class="software-card__icon software-card__icon-download" :href="data.downloadUrl"></a>
                    <software-bookmark inline-template :data="data">
                        <a class="software-card__icon software-card__icon-bookmark" href="#" v-on:click.prevent="handleBookmark()" :data-software-id="data.id" ref="bookmark"></a>
                    </software-bookmark>
                    <a class="software-card__icon software-card__icon-arrow" :class="{inactive: !data.viewDetailsUrl}" :href="data.viewDetailsUrl"></a>
                </div>
            </div>
        </div>
    </div>
`;

export const articleItem = `
<div class="article-card-h">
    <div class="article-card-h__wrapper">
        <div class="article-card-h__row">
            <div class="article-card-h__area article-card-h__area-utils">
                <div class="article-card-h__util article-card-h__util-bookmark">
                    <div class="bookmark-container">
                        <article-bookmark inline-template :data="data">
                            <span class="article-card-h__bookmark" :data-product-id="data.id" ref="bookmark" v-on:click="handleBookmark()" v-bind:class="isBookmarked ? 'active' : ''"></span>
                        </article-bookmark>
                    </div>
                </div>
            </div>
            <div class="article-card-h__area article-card-h__area-image" v-bind:style="{ backgroundImage: 'url(' + data.articleImageUrl + ')' }">
            </div>
            <div class="article-card-h__area article-card-h__area-content">
                <div>
                    <p class="article-card-h__title">
                        \{{data.articleTitle}}
                    </p>
                    <div class="article-card-h__copy">
                        <p>\{{data.articleDetails}}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

`;